'use client';

import * as React from 'react';
import ApplyPermissionGroupModalContent from '@/app/dashboard/staff-settings/permissions/[id]/components/apply-permission-group-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function ApplyPermissionGroupModal(): React.JSX.Element | null {
  const { modal } = useAppSelector(getUi);

  if (!modal?.content) return null;

  return (
    <ModalLayout title="Apply Permission Group" isOpen={modal?.open === ModalDrawer.APPLY_PERMISSION_GROUP}>
      <ApplyPermissionGroupModalContent />
    </ModalLayout>
  );
}
